import { gql, useMutation } from '@apollo/client'

const QUESTION_UPDATE_MUTATION = gql`
  mutation QuestionUpdate($questionId: Long!, $question: QuestionUpdate!) {
    questionUpdate(id: $questionId, question: $question) {
      id
      type
      text
      textFuture
      description
      associatedLink
      notApplicable
      dimension {
        id
        name
      }
      options {
        value
      }
      recommendations {
        stage {
          id
          name
        }
        above
        bellow
      }
      errors {
        message
      }
    }
  }
`

export function useQuestionUpdateMutation(...args) {
  const [mutation, { data, ...rest }] = useMutation(QUESTION_UPDATE_MUTATION, ...args)

  return [
    mutation,
    {
      data: data?.questionUpdate,
      ...rest
    }
  ]
}
